export default __webpack_public_path__ + "static/media/gallery-8.2cb07c7f.jpg";